// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__tCimn","inactiveButton":"styles_inactiveButton__+AcjV"};